import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import sr from './locales/sr.json';
import en from './locales/en.json';
import sl from './locales/sl.json';
import it from './locales/it.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import ru from './locales/ru.json';

// Podržani jezici (konfigurabilno po operateru; snima se u auth.Users.jezik)
export const LANGS = [
    { code: 'sr', label: 'Srpski' },
    { code: 'en', label: 'English' },
    { code: 'sl', label: 'Slovenščina' },
    { code: 'it', label: 'Italiano' },
    { code: 'de', label: 'Deutsch' },
    { code: 'fr', label: 'Français' },
    { code: 'ru', label: 'Русский' },
];

const saved = localStorage.getItem('appLang') || 'sr';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            sr: { translation: sr },
            en: { translation: en },
            sl: { translation: sl },
            it: { translation: it },
            de: { translation: de },
            fr: { translation: fr },
            ru: { translation: ru },
        },
        lng: saved,
        fallbackLng: 'sr',
        interpolation: { escapeValue: false },
        returnEmptyString: false,
        react: { useSuspense: false },   // bez Suspense — sprečava prazan ekran dok se prevodi "spremaju"
    });

// Menja jezik + pamti lokalno (DB je merodavan, postavlja se na login).
export const setAppLanguage = (code) => {
    if (!LANGS.some(l => l.code === code)) code = 'sr';
    localStorage.setItem('appLang', code);
    i18n.changeLanguage(code);
};

export default i18n;
